// @ts-nocheck
import React from 'react';
import { values, compact } from 'lodash';

export interface AsyncProps {
  parameters: any;
}

export interface AsyncState {
  parameters: {
    [key: string]: any;
  };
  isLoaded: boolean;
  isLoading: boolean;
  hasError: boolean;
  error?: string[];
}

export class AsyncComponent<TParameters, TProps extends AsyncProps, TState extends AsyncState> extends React.Component<TProps, TState> {
  static defaultProps = {
    parameters: null,
  };

  static DEFAULT_STATE: Readonly<AsyncState> = {
    parameters: null,
    isLoaded: false,
    isLoading: false,
    hasError: false,
    error: null,
  };

  static getDerivedStateFromProps(props: AsyncProps, state: AsyncState) {
    if (JSON.stringify(props.parameters) !== JSON.stringify(state.parameters)) {
      return {
        ...AsyncComponent.DEFAULT_STATE,
        parameters: JSON.parse(JSON.stringify(props.parameters)),
      };
    }

    return null;
  }

  get parameters(): TParameters {
    return this.state.parameters as TParameters;
  }

  componentDidMount() {
    return this.maybeLoad();
  }

  componentDidUpdate() {
    return this.maybeLoad();
  }

  get shouldLoad() {
    return compact(values(this.props.parameters)).length
      && !this.state.isLoaded
      && !this.state.isLoading;
  }

  setStateAsync(state) {
    return new Promise((resolve) => this.setState(state, resolve));
  }

  async load() {
    // override
  }

  async reset() {
    // override
  }

  async execute(fn) {
    let error = null;

    try {
      await this.setStateAsync({
        isLoading: true, isLoaded: false, hasError: error != null, error,
      });

      await fn();
    } catch (ex) {
      // TODO(zhm) this logic should not be in the base component
      if (ex.response && ex.response.body.membership) {
        if (ex.response.body.membership.errors.base != null) {
          error = ex.response.body.membership.errors.base.map(
            (err: string) => err,
          );
        } else {
          error = ex.response.body.membership.errors.email.map((err: string) => {
            const valid = 'A valid email must be provided';
            const taken = 'This email is associated with another user account';

            switch (err) {
              case 'must be provided':
                return valid;
              default:
                return taken;
            }
          });
        }
      }
      console.error(ex);
    } finally {
      await this.setStateAsync({
        isLoading: false, isLoaded: true, hasError: error != null, error,
      });
    }
  }

  async reload() {
    await this.setStateAsync(AsyncComponent.DEFAULT_STATE);
    await this.maybeLoad();
  }

  async maybeLoad() {
    if (!this.shouldLoad) {
      return;
    }

    this.execute(async () => {
      await this.reset();
      await this.load();
    });
  }
}
